// formReducer.js
const initialState = {
    givenName: '',
    surname : '',
    stateOrProvinceName : '',
    organizationName : 'Unaffiliated',
    serialNumber: '',
    countryName : 'IR',
    commonName: ''
};

const CompleteInfoReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_CSR_INFO':
            return {
                ...state,
                givenName: action.payload.givenName,
                surname: action.payload.surname,
                stateOrProvinceName: action.payload.stateOrProvinceName,
                organizationName: action.payload.organizationName,
                serialNumber: action.payload.serialNumber,
                countryName: action.payload.countryName,
                commonName: action.payload.commonName,
            };
        case 'RESET_CERTIFICATE_FLOW':
            return initialState;
        default:
            return state;
    }
};

export default CompleteInfoReducer;
  